import { useEffect } from 'react';

import { ClaimedReportMonitorTiles } from 'components/idMonitor/ClaimedReportMonitorsContainer/ClaimedReportMonitorTiles';

export const IdMonitor = () => {
  useEffect(() => {
    window.history.replaceState({}, '', window.location.pathname);
  }, []);

  return <ClaimedReportMonitorTiles />;
};
